import { Box, Typography } from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput';
import FormGridItem from '~/components/FormComponents/FormGridItem';
import { InfoTooltip } from '~/components/InfoTooltip/InfoTooltip';
import { rangeTooltip } from '../../../constants';
import { commonStyles } from '~/theme/styles/commonStyles';

interface ISharedRangeGroupProps {
  ownerLabel: string;
  rangePath: string;
  onBlur: () => void;
}

export const SharedRangeGroup = ({ ownerLabel, rangePath, onBlur }: ISharedRangeGroupProps) => {
  return (
    <>
      <FormGridItem>
        <FormInput
          name={`${rangePath}.number`}
          placeholder={`Введіть кількість ${ownerLabel}`}
          label={`Кількість ${ownerLabel}`}
          fullWidth
          onBlur={onBlur}
        />
      </FormGridItem>
      <FormGridItem>
        <Box sx={{ ...commonStyles.centerFlexContainer, gap: 1, pb: 1 }}>
          <Typography
            variant="body2"
            sx={{ color: 'textPrimary', whiteSpace: 'pre-line', alignSelf: 'flex-end' }}
          >
            Діапазон частки {ownerLabel} (%)
          </Typography>
          <InfoTooltip
            title={
              <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                {rangeTooltip}
              </Typography>
            }
            placement="bottom"
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <FormInput
            name={`${rangePath}.from`}
            placeholder="від"
            sx={{ width: '50%' }}
            onBlur={onBlur}
          />
          <Typography variant="h3" sx={{ mb: 2, color: 'textDisabled' }}>
            -
          </Typography>
          <FormInput
            name={`${rangePath}.to`}
            placeholder="до"
            sx={{ width: '50%' }}
            onBlur={onBlur}
          />
          <Typography variant="body1" sx={{ mb: 2, color: 'textDisabled' }}>
            %
          </Typography>
        </Box>
      </FormGridItem>
    </>
  );
};
